module.exports = __webpack_public_path__ + "static/des-2-e9c1d1350295c07f2f6c47fd8ecc1c1f.png";